import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { useMemo, useCallback } from 'react';
import some from 'lodash/some';
import TracksMenu from '../TracksMenu/TracksMenu.js';
import { jsx } from 'react/jsx-runtime';
import '../TracksMenu/TracksMenu.scss';

var disabledSubtitlesTrack = {
  id: 'off',
  iso: 'off'
};
function SubtitleTracksMenu(_ref) {
  var tracks = _ref.tracks,
    onSelectTrack = _ref.onSelectTrack,
    onDisableSubtitles = _ref.onDisableSubtitles,
    title = _ref.title,
    getLanguageLabel = _ref.getLanguageLabel;
  var isAnyTrackSelected = useMemo(function () {
    return some(tracks, 'isSelected');
  }, [tracks]);
  var tracksWithOff = useMemo(function () {
    return [_objectSpread(_objectSpread({}, disabledSubtitlesTrack), {}, {
      isSelected: !isAnyTrackSelected
    })].concat(_toConsumableArray(tracks));
  }, [isAnyTrackSelected, tracks]);
  var onSelectTrackCallback = useCallback(function (track) {
    if (track.id === disabledSubtitlesTrack.id) {
      onDisableSubtitles();
    } else {
      onSelectTrack(track);
    }
  }, [onSelectTrack, onDisableSubtitles]);
  return /*#__PURE__*/jsx(TracksMenu, {
    title: title,
    tracks: tracksWithOff,
    onSelectTrack: onSelectTrackCallback,
    getLanguageLabel: getLanguageLabel
  });
}
SubtitleTracksMenu.defaultProps = {
  tracks: [],
  onSelectTrack: function onSelectTrack() {},
  onDisableSubtitles: function onDisableSubtitles() {},
  title: '',
  getLanguageLabel: function getLanguageLabel() {}
};

export { SubtitleTracksMenu as default };
//# sourceMappingURL=SubtitleTracksMenu.js.map
